/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileTabs_tradeFirm = {
    readonly publicProfile: {
        readonly urlLabel: string | null;
        readonly designProjectsCount: number | null;
        readonly portfolios: ReadonlyArray<{
            readonly itemCount: number | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ProfileTabs_tradeFirm";
};
export type ProfileTabs_tradeFirm$data = ProfileTabs_tradeFirm;
export type ProfileTabs_tradeFirm$key = {
    readonly " $data"?: ProfileTabs_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileTabs_tradeFirm">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileTabs_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designProjectsCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioV1",
          "kind": "LinkedField",
          "name": "portfolios",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
(node as any).hash = 'e22a1a2809e4d185dc9aaff2d6e2d68b';
export default node;
